import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env['VITE_FIREBASE_API_KEY'] as string,
  authDomain: import.meta.env['VITE_FIREBASE_AUTH_DOMAIN'] as string,
  projectId: import.meta.env['VITE_FIREBASE_PROJECT_ID'] as string,
  storageBucket: import.meta.env['VITE_FIREBASE_STORAGE_BUCKET'] as string,
  messagingSenderId: import.meta.env['VITE_FIREBASE_MESSAGING_SENDER_ID'] as string,
  appId: import.meta.env['VITE_FIREBASE_APP_ID'] as string,
};

// Guard against double-initialisation during Vite HMR
const app: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]!;

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(
  app,
  (import.meta.env['VITE_FIREBASE_REGION'] as string | undefined) ?? 'europe-west2'
);

if (import.meta.env['VITE_USE_EMULATORS'] === 'true') {
  // Ports are overridable so two sessions can run the app against two
  // emulator suites on one machine. Defaults are the ones firebase.json uses,
  // so nothing changes for anyone who does not set them.
  const port = (key: string, fallback: number) => Number(import.meta.env[key] ?? fallback);
  connectAuthEmulator(auth, `http://127.0.0.1:${port('VITE_EMULATOR_AUTH_PORT', 9099)}`, { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', port('VITE_EMULATOR_FIRESTORE_PORT', 8080));
  connectStorageEmulator(storage, '127.0.0.1', port('VITE_EMULATOR_STORAGE_PORT', 9199));
  connectFunctionsEmulator(functions, '127.0.0.1', port('VITE_EMULATOR_FUNCTIONS_PORT', 5001));
}


export default app;
